module.exports = __webpack_public_path__ + "img/a5.623353a1.png";